export default __webpack_public_path__ + "static/running_paris-03d42d5240912c16866220e66ef436fd.jpg";